import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle `
  body {
    /* Override hubspot default styles */
    #hubspot-messages-iframe-container {
      z-index: 1;
    }
  }
`;
